import lurna_white_logo from './lurna_white_logo.png';
import authpageimg from './authpageimg.png';
import authpageimg2 from './authpageimg2.png';
import oh_no_img from './oh_no_image.png'
import create_from_note_img from './create_from_note_img.png'
import create_from_note_img_dark from './create_from_note_img_dark.png'
import create_manually_img from './create_manually_img.png'
import create_manually_img_dark from './create_manually_img_dark.png'
import create_from_files_img from './create_from_files_img.png'
import create_from_files_img_dark from './create_from_files_img_dark.png'
import create_from_youtube_img from './create_from_youtube_img.png'
import create_from_youtube_img_dark from './create_from_youtube_img_dark.png'
import create_from_paste_img from './create_from_paste_img.png'
import create_from_paste_img_dark from './create_from_paste_img_dark.png'
import create_from_quizlet_img from './create_from_quizlet_img.png'
import create_from_quizlet_img_dark from './create_from_quizlet_img_dark.png'
import annotate_notes_img from './annotate_notes_img.png'
import normal_notes_img from './normal_notes_img.png'
import shape_7 from './shape_7.png'
import shape_9 from './shape_9.png'
import shape_19 from './shape_19.png'
import geometric_shapes_poster from './Geometric Shapes Poster.png'
import notes_onboarding_img from './notes_onboarding_img.png';
import organize_onboarding_img from './organize_onboarding_img.png';
import learn_onboarding_img from './learn_onboarding_img.png';
import master_onboarding_img from './master_onboarding_img.png';
import pricing_bg_img from './pricing_bg_img.png';
import lurna100betaimg from './lurna-1.0.0-beta-img.png';
import lurna_logo from './lurna_logo.png';
import google_drive_logo from './google-drive.png';
import light_mode_img from './light_mode_img.png';
import dark_mode_img from './dark_mode_img.png';
import system_img from './system_img.png';
import pricing_gradient_img from './pricing_gradient_img.jpg';
import pricing_gradient_img_2 from './pricing_gradient_img_2.jpg';
import limited_time_pricing_img from './limited_time_pricing_img.jpg'
import whats_new_gradient_img from './whats_new_gradient_img.png'
import correct_answer_sound from './correct_answer_sound.mp3'
import level_complete_sound from './level_complete_sound.mp3'
import practice_test_noti_img from './practice_test_noti_img.png'

export const assets = {
    lurna_white_logo,
    authpageimg,
    authpageimg2,
    oh_no_img,
    create_from_note_img,
    create_from_note_img_dark,
    create_manually_img,
    create_manually_img_dark,
    create_from_files_img,
    create_from_files_img_dark,
    create_from_youtube_img,
    create_from_youtube_img_dark,
    create_from_paste_img,
    create_from_paste_img_dark,
    create_from_quizlet_img,
    create_from_quizlet_img_dark,
    annotate_notes_img,
    normal_notes_img,
    shape_7,
    shape_9,
    shape_19,
    geometric_shapes_poster,
    notes_onboarding_img,
    organize_onboarding_img,
    learn_onboarding_img,
    master_onboarding_img,
    pricing_bg_img,
    lurna100betaimg,
    lurna_logo,
    google_drive_logo,
    light_mode_img,
    dark_mode_img,
    system_img,
    pricing_gradient_img,
    pricing_gradient_img_2,
    limited_time_pricing_img,
    whats_new_gradient_img,
    correct_answer_sound,
    level_complete_sound,
    practice_test_noti_img
}
